var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "Tooltip",
        {
          staticClass: "ml-8",
          attrs: {
            title: _vm.activityTooltip.title,
            placement: "right",
            tooltipClasses: _vm.activityTooltip.classes,
            disabled: _vm.activityTooltipDisabled,
            variant: _vm.TooltipVariants.LIGHT,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-row h-1 justify-flex-start items-center",
            },
            [
              _c("p", { staticClass: "grayTitle" }, [_vm._v("Task:")]),
              _c("CardBodySingleChip", {
                attrs: {
                  label: "",
                  customContainerClass: "-mt-1.5",
                  labelStyle:
                    "text-blue font-outfit text-xs font-normal w-max-content",
                  chipDetails: _vm.activityChipDetails,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "Tooltip",
        {
          staticClass: "-mt-1 ml-8",
          attrs: {
            title: "You do not have access to this project",
            tooltipClasses: "w-44",
            placement: "right",
            disabled: _vm.projectAccessTooltipDisabled,
            variant: _vm.TooltipVariants.LIGHT,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-row h-1 justify-flex-start items-center",
            },
            [
              _c("p", { staticClass: "grayTitle" }, [_vm._v("Project:")]),
              _c("CardBodySingleChip", {
                attrs: {
                  label: "",
                  initialLabel: "adjustNewMargin",
                  customContainerClass: "-mt-1.5",
                  labelStyle:
                    "text-blue font-outfit text-xs font-normal w-max-content",
                  chipDetails: _vm.projectChipDetails,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }